console.info('Plugin: cewerk Blocks, loaded');

import "@fancyapps/ui/dist/carousel/carousel.css";
import "@fancyapps/ui/dist/carousel/carousel.autoplay.css";


// -------- blocks
import "../src/blocks/slider.css";

// -------- main
import "../src/index.css";
document.addEventListener("DOMContentLoaded", () => {


});
